<zest-title-step *ngIf="contentLoaded" [mainTitle]="headerMessage"></zest-title-step>
<div class="card">
  <div class="content">
    <div class="row">
      <div class="margin-bottom text-center">
        <div><img class="check-circle" [src]="'../../../assets/images/'+image" /></div>
        <span [textContent]="statusText"></span>
      </div>
      <div class="col s12 m12 l12">
        <div class="row">
          <div class="zest-card" *ngIf="application && showCard === true">
            <div class="row section border">
              <div class="col s2"> <img class="logo-img" [src]="s3BucketUrl+'/logo-icons/'+(application.MerchantName | lowercase)+'-logo-icon.png'"
                /></div>
              <div class="col s10">
                <h6 class="merchant-name" [textContent]="application.MerchantName"></h6>
                <p class="order-id" [textContent]="'Order #' + application.MerchantOrderId"></p>
              </div>
            </div>
            <div class="row section">
              <div class="col s12">
                <div class="row inner-section dashed">
                  <div class="col s8 row-label left">ZestMoney loan ID </div>
                  <div class="col s4 row-label right" [textContent]="mambuId"></div>
                </div>
                <div class="row inner-section dashed">
                  <div class="col s8 row-label left">Order amount</div>
                  <div class="col s4 row-label right" [textContent]="(application.BasketAmount | RupeeCurrencyPipe)"></div>
                </div>
                <div class="row inner-section">
                  <div class="col s8 row-label left">Downpayment amount</div>
                  <div class="col s4 row-label right" [textContent]="((application.DownpaymentAmount + application.ProcessingFee) | RupeeCurrencyPipe)"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row center-div">
          <div class="row text-center margin-top-3pc margin-bottom-0px">
            <div class="col s12">
              <button [disabled]="linkStatus==='PENDING_TRANSACTION'" [class]="'btn waves-effect zest-btn ladda-button'" (click)="login()">
              <span>Login </span>
            </button>
            </div>
            <p class="disclaimer" [textContent]="footerMessage">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>